import { HeaderFooterStyle } from './header-footer-style.enum';
import { TicketTenantSettingsBuilder } from './../ticket-tenant-settings/ticket-tenant-settings.builder';
import { HelpCenterVisibility, DomainMappingMethod } from './tenant.i';
import { ArticlesVisibilitySettingsBuilder } from '../../common/articles-visibility/articles-visibility-settings.builder';
import { HelpcenterContactSettingsBuilder } from '../helpcenter-contact-settings/helpcenter-contact-settings.builder';
var TenantBuilder = /** @class */ (function () {
    function TenantBuilder() {
        this.tenant = {
            id: '84c9d5dc-ce4b-432d-9477-84f0d6a37f30',
            defaultLang: 'en',
            adminUserId: '84c9d5dc-ce4b-432d-9477-84f0d6a37f30',
            settings: {
                appearance: {
                    name: 'Test',
                    title: 'Test',
                    slogan: 'Bob rulez',
                    disableAnimations: false,
                    color1: '#0099ff',
                    color2: '#8877ff',
                    headerFooterStyle: HeaderFooterStyle.BRANDED,
                    fontFamily: 'Bob Sans FT',
                    backgroundColor: '#445533',
                    backgroundImageUrl: '#989343',
                    backgroundVideoUrl: 'none',
                    logoUrl: 'bob',
                    faviconUrl: 'tost with cheese',
                    templateKey: 'angels-eye',
                    logoTargetUrl: 'http://bob.com'
                },
                site: {
                    disableSeoVisibility: false,
                    secured: false,
                    host: 'bob',
                    path: '',
                    domainMappingMethod: DomainMappingMethod.SUBDOMAIN
                },
                general: {
                    languages: ['en', 'de', 'es', 'fr', 'it'],
                    reportRecipients: [],
                    webhooks: [],
                    scripts: [],
                    styles: [],
                    allowedDomains: []
                },
                helpCenter: {
                    privacy: HelpCenterVisibility.PUBLIC,
                    enableSeoRenderer: true,
                    disableSeoVisibility: false,
                    noLogin: false,
                    multilingualSettings: {
                        de: {
                            scope: new ArticlesVisibilitySettingsBuilder().build(),
                            contact: new HelpcenterContactSettingsBuilder().build()
                        },
                        en: {
                            scope: new ArticlesVisibilitySettingsBuilder().build(),
                            contact: new HelpcenterContactSettingsBuilder().build()
                        },
                        es: {
                            scope: new ArticlesVisibilitySettingsBuilder().build(),
                            contact: new HelpcenterContactSettingsBuilder().build()
                        },
                        fr: {
                            scope: new ArticlesVisibilitySettingsBuilder().build(),
                            contact: new HelpcenterContactSettingsBuilder().build()
                        },
                        it: {
                            scope: new ArticlesVisibilitySettingsBuilder().build(),
                            contact: new HelpcenterContactSettingsBuilder().build()
                        }
                    }
                },
                sso: {
                    enabled: false,
                    formUrl: '',
                    logoutUrl: '',
                    apiKey: '84c9d5dc-ce4b-432d-9477-84f0d6a37f30'
                },
                ticket: new TicketTenantSettingsBuilder().build(),
                phone: {
                    enabled: false,
                    twilioAccountId: ''
                }
            },
            locales: ['en', 'de', 'es', 'fr', 'it']
        };
    }
    TenantBuilder.prototype.withColor1 = function (color1) {
        this.tenant.settings.appearance.color1 = color1;
        return this;
    };
    TenantBuilder.prototype.withColor2 = function (color2) {
        this.tenant.settings.appearance.color2 = color2;
        return this;
    };
    TenantBuilder.prototype.withHeaderFooterStyle = function (style) {
        this.tenant.settings.appearance.headerFooterStyle = style;
        return this;
    };
    TenantBuilder.prototype.withLogoUrl = function (url) {
        this.tenant.settings.appearance.logoUrl = url;
        return this;
    };
    TenantBuilder.prototype.withFaviconUrl = function (url) {
        this.tenant.settings.appearance.faviconUrl = url;
        return this;
    };
    TenantBuilder.prototype.backgroundImageUrl = function (url) {
        this.tenant.settings.appearance.backgroundImageUrl = url;
        return this;
    };
    TenantBuilder.prototype.withLanguages = function (langs) {
        this.tenant.settings.general.languages = langs;
        return this;
    };
    TenantBuilder.prototype.withLocales = function (locales) {
        this.tenant.locales = locales;
        return this;
    };
    TenantBuilder.prototype.withScripts = function (scripts) {
        this.tenant.settings.general.scripts = scripts;
        return this;
    };
    TenantBuilder.prototype.withAdminUserId = function (id) {
        this.tenant.adminUserId = id;
        return this;
    };
    TenantBuilder.prototype.withStyles = function (styles) {
        this.tenant.settings.general.styles = styles;
        return this;
    };
    TenantBuilder.prototype.withPrivacy = function (visibility) {
        this.tenant.settings.helpCenter.privacy = visibility;
        return this;
    };
    TenantBuilder.prototype.withSsoEnabled = function (enabled) {
        this.tenant.settings.sso.enabled = enabled;
        return this;
    };
    TenantBuilder.prototype.withSsoLoginFormUrl = function (formUrl) {
        this.tenant.settings.sso.formUrl = formUrl;
        return this;
    };
    TenantBuilder.prototype.withSsoLogoutUrl = function (url) {
        this.tenant.settings.sso.logoutUrl = url;
        return this;
    };
    TenantBuilder.prototype.withArticlesVisibilitySettings = function (lang, settings) {
        this.tenant.settings.helpCenter.multilingualSettings[lang].scope = settings;
        return this;
    };
    TenantBuilder.prototype.withTicketMultilingualSettings = function (lang, settings) {
        this.tenant.settings.ticket.multilingualSettings[lang] = settings;
        return this;
    };
    TenantBuilder.prototype.withTicketTenantSettings = function (ticketTenantSettings) {
        this.tenant.settings.ticket = ticketTenantSettings;
        return this;
    };
    TenantBuilder.prototype.withPhoneTenantSettings = function (phoneTenantSettings) {
        this.tenant.settings.phone = phoneTenantSettings;
        return this;
    };
    TenantBuilder.prototype.build = function () {
        return this.tenant;
    };
    return TenantBuilder;
}());
export { TenantBuilder };
//# sourceMappingURL=tenant-builder.js.map